module.exports = __webpack_public_path__ + "@/assets/img/cambios.fa58e799.svg";